<template>
  <div class="login">
    <!-- 直接进入页面，但得关闭自动删除token -->
    <!-- <div style='width:100px;height:100px;background:red;' @click='goIndex'></div> -->
    <div class="all">
      <!-- 顶部绿条 -->
      <div class="top"></div>
      <!-- 图片 -->
      <img class="login_logo" src="../../public/images/login_logo.png" alt="">
      <div class="login_txt">  
        家谱纪后台登录系统
      </div>
      
      <Input  ref='isFocuseA'   size='large' :maxlength='20'  class='ipt' prefix="md-person" placeholder="请输入用户名称" @keyup.enter.native="mobileFun" v-model="mobile"  clearable/>

      <Input  ref='isFocuseB'  size='large' :maxlength="20"  type='password' class="ipt" prefix="ios-lock" placeholder="请输入登录密码"  @keyup.enter.native="passwordFun"  v-model="password" clearable />
      
      <Input   ref='isFocuseC'  size='large' :maxlength="20"  type='text' class="ipt  yzmc" prefix="ios-keypad" placeholder="请输入验证码"  @keyup.enter.native="codeFun"  v-model="yzm" clearable />
      
      <img    :src="yzmImg" @click='yzmFun' class="yzmc  yzmr" alt="">
      
      <div class="tan"></div>

      <Button class="login_btn " @click='send'>登录</Button>
      
      
    </div>
      
   <!-- {{globalUrl}} -->

    <div class="bg">
      <img src="../../public/images/login_bg.png" alt="">
    </div>
  </div>
</template>


<script>

// https://api.jiapuji.net/gateway/
import global from '@/api/common.vue'
// 密码加密
import CryptoJS from 'crypto-js'



// store
import { mapState,mapMutations,mapGetters } from 'vuex';

export default {
  name: "login",
  data () {
        return {
          globalUrl:global.httpUrl,
          mobile:'',
          password:'',
          yzm: '',
          yzmImg: 'https://api.jiapuji.vip/gateway/oauth2/service/admin/login/code?num=1',
         
          
         
        }
    },
    
    watch:{        
      
    },
    computed: {
      is_change_load(){     
          return this.$store.getters.is_change_load
      },
        
    },
    methods: {
        
        clearFun(){
            var that = this;
            
            that.$store.commit('change_token','');
            that.$store.commit('change_image','');
            that.$store.commit('change_guid','');
            that.$store.commit('change_name','');
            that.$store.commit('change_mobile','');
            that.$store.commit('change_password','');
            that.$store.commit('change_checkGuid','');
            that.$store.commit('change_checkGuid2','');
      
        },
        
        send(){
          var that = this;
           var myreg = /^1(3|4|5|6|7|8|9)\d{9}$/;
         
          if(that.mobile == null || that.mobile == ''){
              this.$Message.info({
                
                  content:'请输入手机号码',
                  duration:3
              });
          }else if(that.password.length<6){
                this.$Message.info({
                
                      content:'密码大于6位数',
                      duration:3
                }); 
          }else if(false){

          }else{
            var  password = that.password.replace(/\s*/g,"");
            var my_password = CryptoJS.HmacSHA1(password, "OT2NDh41").toString().toUpperCase();
            // var  my_password = encryptDes(that.password, "OT2NDh41").toString().toUpperCase();
            // console.log(my_password)
            
            that.$ajax({
              method:'post',
              url: 'oauth2/admin/login',
              credentials: 'include',
              xhrFields: {

                withCredentials: true

              },
              crossDomain: true,
              data:{
                'mobile': that.mobile.replace(/\s*/g,""),
                'password': my_password,
                'code': that.yzm
                
              }
            }).then(res => {
              
              // console.log(that.mobile,that.password);
              // 缓存
              var res = res.data;
              if(res.code != 1){
                that.$Message.info({
                    content:res.message,
                    duration:3
                });
              }
              var user_token ;
              if(!res.data.token&&res.data.token == null&&res.data.token == undefined){
                user_token = ''
              }else{
                
                user_token = res.data.token;
              }
              
              var user_name = res.data.user.surname + res.data.user.name;
              var user_guid = res.data.user.guid;
              var user_sex = res.data.user.sex;
              var user_createTime = res.data.user.createTime;
              var user_lastLoginTime = res.data.user.lastLoginTime;
              var user_image = res.data.user.image;
              var user_mobile = res.data.user.mobile;
              var user_password = that.password;   

              if(!user_image||user_image == undefined){
                user_image = null;
              }
           
              // console.log(user_token)
             
              
              if(res.message == '操作成功'){
                  // 缓存token等数据
                  that.$store.commit('change_token',user_token);
                  that.$store.commit('change_image',user_image);
                  that.$store.commit('change_guid',user_guid);
                  that.$store.commit('change_name',user_name);
                  that.$store.commit('change_mobile',user_mobile);
                  that.$store.commit('change_password',user_password);
                  that.$store.commit('change_checkGuid',user_guid);
                  that.$store.commit('change_checkGuid2',user_guid);

                  that.$myAjax.get('admin/service/admin/menu_user').then(res2 => {
                    that.menu = res2.data.data.menu;
                    // 缓存菜单
                    that.$store.commit('change_menu',that.menu);
                    
                    if(res.data.menu == 0){
                      that.$Message.info({
                          content:'您没有后台权限',
                          duration:3
                      });
                    }else if(res.data.menu == 1){
                      // 清空验证码和密码
                      that.yzm = null;
                      that.password = null;
                     
                      //自动生成路由
                      function fun(res, n=0){             //获取menu
                        n++;
                        let v = [];
                        
                        for(let i=0;i<res.length;i++){
                          if( n == 1 ){
                            v.push({ id:n,path: res[i].url,name: res[i].title,component:eval( () => import("."+res[i].url+".vue")),redirect: res[i].children.length >0 ? res[i].children[0].url : null,children: fun(res[i].children,n)})
                          }else {
                            if(  (res[i].isButton === 0 || n == 2) ){
                              v.push({ id:n,path: res[i].url,name: res[i].title,component:eval( () => import("."+res[i].url+".vue")),children: fun(res[i].children,n)})
                            } 
                          }
                        }
                        return v;
                      }
 
                      this.$router.options.routes = [
                        {
                          path: "/",
                          name: "/login",
                          component: () => import("./login.vue")
                        },
                        {
                          path: "/layout",
                          name: "/layout",
                          component: () => import("./layout.vue"),
                          redirect:"/layout/home",
                          children: fun(that.menu)
                        },
                        {
                          path: "*",
                          name: "NULL",
                          component: () => import("./NULL.vue"),
                          path: "/NULL"
                          
                          
                        }
                      
                      ];
                      
                      this.$router.addRoutes(this.$router.options.routes);
                      // 跳转首页
                      // console.log(111,this.$router.options.routes)
                      that.goIndex();
                      
                      
                      
                    }else{
                      that.$Message.info({
                          content:'未知权限',
                          duration:3
                      });
                    }
                  })
                
                
              }else{

                  that.$Message.info({
                      content:res.message,
                      duration:3
                  });
              }
             
            }).catch(err =>{
              
              // that.$alert.info(err)
            })

          }
          
        },
        goIndex(){
          var that = this;
          let rou = that.menu[0].url;
          console.log(rou)
          that.$router.push({path:rou});
        },
        // mobile 回车键
        mobileFun(){
          var that = this;
          that.$nextTick(()=>{       
            that.$refs['isFocuseB'].focus();
          })
          
        },
        // password 回车键
        passwordFun(){
          var that = this;
          that.$nextTick(()=>{       
            that.$refs['isFocuseC'].focus();
          })
         
        },
        //CODE 验证码
        codeFun(){
          this.send();
          
        },
       //验证码图片
        yzmFun(){
          let that = this;
          let num = (new Date()).valueOf();
          that.yzmImg = 'https://api.jiapuji.vip/gateway/oauth2/service/admin/login/code?num='+num;
          that.yzm = null;
        
        },
    },
    mounted: function(){
        
        var that = this;
        this.$store.commit('change_load',true);
        //vuex全为''
        that.clearFun();
        // 删除跳转记录
        that.$router.replace;
        // 自动获取焦点
        that.$nextTick(()=>{
          that.$refs['isFocuseA'].focus();
        })

    }

}

</script>
<style scoped>
  
  

  .login{
    width: 100%;
    height: 100%;
  }
  .login *{
    text-align: center;
  }
  .login .all{
    position: absolute;
    top: 0;left: 0;bottom: 0;right: 0;
    margin: auto;
    width: 350px;
    height: 420px;
    box-shadow: 2px 2px 2px  rgba(153, 142, 142,0.3),
                2px 2px 2px  rgba(153, 142, 142,0.3),
                -2px -2px 2px  rgba(153, 142, 142,0.3),
                -2px -2px 2px  rgba(153, 142, 142,0.3);
    
    z-index: 999;
    background: white;

  }
  .login .top{
    position: absolute;
    top: -10px;left: 0;
    width: 100%;
    height: 10px;
    background: #1abc9c;

  }
  
  .login .login_logo{
    width: 90.2px;
    height: 80px;
    margin-top: 15px;
  }
  .login .login_txt{
    width: 100%;
    height: 45px;
    line-height: 45px;
    font-size: 25px;
    color: #1abc9c;
    text-align: center;
    font-weight: 900;
   
  }
  .login .ipt{
    width: 300px;
    margin-top: 15px;
    margin-bottom: 15px;

  }

  .login .tan{
    width: 100%;
    height: 10px;
    /* background: red; */
    margin: 10px 0;
  }
  .login .login_btn{
    width: 300px;  
    font-size: 20px;
    font-weight: 400 ;
    color: white ;
    background: #1abc9c ;
    margin-top: 10px;
   
  }

  /* 背后绿条 */
  .login .bg{
    position: fixed;
    top: 50%;left: 0;
    transform: translateY(-50%);
    width: 100%;
    height: 220px;
    z-index: 99;
  }
  .login .bg img{
    width: 100%;
    height: 100%;
  }
  .yzmc{
    float: left;
    width: 155px !important;
    margin-top: 15px;
    margin-left: 25px;
  }
  .yzmr{
    width: 120px !important;
    border-radius: 3px;
  }
</style>

